import { render } from "./OfferItem.vue?vue&type=template&id=57a60ca0"
import script from "./OfferItem.vue?vue&type=script&lang=js"
export * from "./OfferItem.vue?vue&type=script&lang=js"

import "./OfferItem.vue?vue&type=style&index=0&id=57a60ca0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__